// Safari doesn't support WebM — MediaRecorder(stream) with no mimeType silently records
// MP4/AAC there instead. Always read back the recorder's actual mimeType rather than
// assuming webm, so the upload filename/extension (and the Content-Type the backend
// stores) match what was really recorded. Mislabeling it plays back fine nowhere later
// (any browser, any device) even though transcription still works, since ffmpeg auto-
// probes the real format regardless of what it's told.

const PREFERRED_MIME_TYPES = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/mpeg'];

// Pass as MediaRecorder(stream, { mimeType }) so we get our preferred format when the
// browser supports one, instead of leaving the choice entirely up to the browser.
export function pickRecorderMimeType() {
  if (typeof MediaRecorder === 'undefined' || !MediaRecorder.isTypeSupported) return '';
  return PREFERRED_MIME_TYPES.find((t) => MediaRecorder.isTypeSupported(t)) || '';
}

// Extension to upload the recording under — must match its real (recorder-reported) mimeType,
// not be hardcoded, since the backend derives Content-Type from this filename's extension.
export function extensionForMimeType(mimeType) {
  const type = (mimeType || '').toLowerCase();
  if (type.includes('mp4')) return 'mp4';
  if (type.includes('mpeg') || type.includes('mp3')) return 'mp3';
  if (type.includes('ogg')) return 'ogg';
  return 'webm';
}
